import type { Entry } from "@/shared/types/entries";
import { type FirmDomain, getFirmDomain } from "@/shared/utils/firm";

export const PROLAW_CUTOFF_LOCK_MESSAGE =
	"Things exported before the ProLaw cut-off can't be modified.";

/** Friday, August 14, 2026 at 5:00 PM Pacific (PDT). */
export const TYSON_MENDES_PROLAW_CUTOFF_MS = Date.parse(
	"2026-08-15T00:00:00.000Z",
);

type ExportMutationEntry = Pick<Entry, "status" | "entryExportedAt">;

export function isTysonMendesProLawCutoffLocked(
	entry: ExportMutationEntry,
	firmDomain: FirmDomain = getFirmDomain(),
): boolean {
	if (firmDomain !== "tysonmendes" || entry.status !== "exported") {
		return false;
	}

	const exportedAtMs = entry.entryExportedAt
		? Date.parse(entry.entryExportedAt)
		: Number.NaN;
	return (
		!Number.isFinite(exportedAtMs) ||
		exportedAtMs < TYSON_MENDES_PROLAW_CUTOFF_MS
	);
}

/**
 * Exported entries are terminal for every firm except Tyson Mendes entries
 * exported at or after the ProLaw cut-off.
 */
export function canModifyExportedEntry(
	entry: ExportMutationEntry,
	firmDomain: FirmDomain = getFirmDomain(),
): boolean {
	if (entry.status !== "exported") return true;
	if (firmDomain !== "tysonmendes") return false;
	return !isTysonMendesProLawCutoffLocked(entry, firmDomain);
}
